import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-break" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Please wait... ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: `${_ctx.t('common.confirmDelete')}`,
    id: `vz_modal_delete_${_ctx.viewName}`,
    showDialog: _ctx.showDialog,
    widthClass: 'width-550',
    onModalClose: _ctx.close,
    viewName: "VZDelete"
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        id: "closeButtonH",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, _toDisplayString(_ctx.t("common.close")), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.applyDelete && _ctx.applyDelete(...args))),
        disabled: _ctx.deleteBtnLoading
      }, [
        (_ctx.deleteBtnLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.deleteBtnLoading ? "" : _ctx.t("common.delete")), 1)
      ], 8, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.deleteText), 1)
    ]),
    _: 1
  }, 8, ["title", "id", "showDialog", "onModalClose"]))
}